export default __webpack_public_path__ + "static/media/ico_right_arrow.5665f6e7.svg";